// Shared sector (category) label lookup — Politics/Economy/Tech/etc.
// Fetches /api/sectors ONCE (module-level cache, shared across every
// component that mounts this hook) and exposes `sectorLabel()` which
// accepts EITHER a raw sector key string (looked up in the cache) OR an
// already-fetched sector object (e.g. from a component that already has
// the full list, like the nav dropdown) — always returning the Urdu
// `label_ur` when `lang === "ur"` and it's set, falling back to the
// English `label` (or the raw key, if the sector can't be resolved at all
// — better than rendering nothing).
import { useEffect, useState } from "react";
import api from "./api";

let _cache = null;
let _fetchPromise = null;

function fetchSectors() {
  if (_cache) return Promise.resolve(_cache);
  if (!_fetchPromise) {
    _fetchPromise = api.get("/sectors").then((r) => {
      _cache = r.data || [];
      return _cache;
    }).catch(() => []);
  }
  return _fetchPromise;
}

export function useSectorLabels() {
  const [sectors, setSectors] = useState(_cache || []);
  useEffect(() => {
    let mounted = true;
    fetchSectors().then((data) => { if (mounted) setSectors(data); });
    return () => { mounted = false; };
  }, []);

  const byKey = {};
  (sectors || []).forEach((s) => { byKey[String(s.key || "").toLowerCase()] = s; });

  const sectorLabel = (keyOrSector, lang) => {
    if (!keyOrSector) return "";
    const s = typeof keyOrSector === "string" ? byKey[keyOrSector.toLowerCase()] : keyOrSector;
    if (!s) return typeof keyOrSector === "string" ? keyOrSector : "";
    return (lang === "ur" && (s.label_ur || "").trim()) ? s.label_ur : s.label;
  };

  return { sectors, sectorLabel };
}
